import { render } from "./ProviderConfirmDetails.vue?vue&type=template&id=2a4c4e56"
import script from "./ProviderConfirmDetails.vue?vue&type=script&lang=js"
export * from "./ProviderConfirmDetails.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__